<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Auth User Applications</h4>
          <a *ngIf="CanCreate" class="btn btn-success" routerLink="/Auth/AuthUserApps/New" role="button" id="btnCreate">
              Create
          </a>
          <app-ngbAccordion class="m-t-10" headerName="Search Criteria">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="useraccount">User Account</label>
                  <input type="text" class="form-control" id="useraccount" [(ngModel)]="model.filter.UserAccount" placeholder="">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="ApplicationID">ApplicationID</label>
                  <input type="text" class="form-control" id="ApplicationID" [(ngModel)]="model.filter.ApplicationID" placeholder="">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>IsEnabled</label>
                  <ng-select [searchable]="false" [items]="model.ddlIsEnabled" bindValue="value" bindLabel="text"
                      [clearable]="false" [(ngModel)]="model.filter.IsEnabled">
                  </ng-select>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-secondary" (click)="this.model.filter.PageIndex = 1;Search()">Search</button>
          </app-ngbAccordion>
          <app-ngbAccordion class="m-t-10" headerName="Search Result">
              <div>
                  <div class="rowCard">
                      <app-table-pager [Income]="TableData" (PageInfo)="onChangePageInfo($event)"></app-table-pager>
                  </div>
                  <app-table [Income]="TableData" [TableSetting]="TableSetting" (TableInfo)="onChangeTableInfo($event)" (DeleteEvent)="Delete($event)">
                  </app-table>
                  <div class="dataTb">
                      <app-table-pager [Income]="TableData" (PageInfo)="onChangePageInfo($event)"></app-table-pager>
                  </div>
              </div>
          </app-ngbAccordion>
        </div>
      </div>
    </div>
  </div>
</div>